import { render } from "./BriefPreview.vue?vue&type=template&id=b1d35dc0&scoped=true"
import script from "./BriefPreview.vue?vue&type=script&lang=js"
export * from "./BriefPreview.vue?vue&type=script&lang=js"

import "./BriefPreview.vue?vue&type=style&index=0&id=b1d35dc0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1d35dc0"]])

export default __exports__